/**
 * Modifier Transformation Utilities
 * Helper functions for transforming modifier selections for cart storage
 */

/**
 * Transform modifier selections from useModifierValidation format to cart format
 * Converts the selection object structure to an array of modifiers with selected options
 * 
 * @param modifierSelections - Object from useModifierValidation hook { "modifier-id": { "option-id": { quantity, option } } }
 * @param modifiersList - Full modifier data array from Redux state
 * @returns Array of modifier objects with selected options for cart storage
 */
export const transformModifierSelectionsForCart = (
  modifierSelections: any,
  modifiersList: any[]
): any[] => {
  const selectedModifiers: any[] = [];
  
  if (!modifiersList || !modifierSelections) {
    return selectedModifiers;
  }
  
  Object.keys(modifierSelections).forEach((modifierId) => {
    const modifier = modifiersList.find((m: any) => m.id === modifierId);
    if (modifier) {
      const selectedOptions: any[] = [];
      const optionSelections = modifierSelections[modifierId];
      
      Object.keys(optionSelections).forEach((optionId) => {
        const optionData = optionSelections[optionId];
        // optionData is an object like: { quantity: 1, option: {...} }
        if (optionData && optionData.quantity > 0) {
          const option = modifier.options.find((o: any) => o.id === optionId);
          if (option) {
            selectedOptions.push(option);
          }
        }
      });
      
      if (selectedOptions.length > 0) {
        selectedModifiers.push({
          ...modifier,
          options: selectedOptions
        });
      }
    }
  });
  
  return selectedModifiers;
};
